import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SignProvidersService } from '@libs/app.services/sign/sign-providers.service';
import { TranslateModule } from '@ngx-translate/core';
import { AppGoogleSigninComponent } from './google-sign-button/app-google-signin';
import { TelegramSignButtonComponent } from './telegram-sign-button/telegram-sign-button.component';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-sign-providers',
  templateUrl: './providers.component.html',
  styleUrl: './providers.component.scss',

  imports: [CommonModule, TranslateModule, AppGoogleSigninComponent, TelegramSignButtonComponent],
})
export class ProvidersComponent {
  button = toSignal(this.service.providers());
  constructor(private service: SignProvidersService) {}
}
